import {Spine} from "pixi-spine";
import { Spine as Spine4, Skin } from "@pixi-spine/runtime-4.1";
import { Graphics, Texture, SCALE_MODES, DisplayObject, RenderTexture } from "pixi.js";
import { IServiceProvider } from "@westpierstudio/luma/services";

//Handles negative values
export function mod(a: number, b: number): number {
    return ((a%b)+b)%b;
}

export function devLog(msg: string): void {

    if (process.env.NODE_ENV !== `production`) {
        console.log(msg);
    }
}

export function toRad(angle: number): number {
    return angle * (Math.PI / 180);
}

export function toDeg(angle: number): number {
    return angle * (180 / Math.PI);
}

export function copyToClipboard(str: string): void {

    const textArea = document.createElement(`textarea`);
    textArea.value = str;
    textArea.setAttribute(`readonly`, ``);
    textArea.style.position = `absolute`;
    textArea.style.left = `-9999px`;
    document.body.appendChild(textArea);

    const selection = (document as Document).getSelection() as Selection;

    const selected = selection.rangeCount > 0 ? selection.getRangeAt(0) : false;

    textArea.select();
    document.execCommand(`copy`);
    document.body.removeChild(textArea);

    if (selected) {

        selection.removeAllRanges();
        selection.addRange(selected);
    }
}

function drawCircle(radius: number, colour: number, alpha=1.0): Graphics {

    const graphic = new Graphics();

    graphic.beginFill(colour, alpha);
    graphic.drawCircle(0, 0, radius);
    graphic.endFill();

    return graphic;
}

export function drawRect(width: number, height: number, colour: number, alpha=1.0): Graphics {

    const graphic = new Graphics();

    graphic.beginFill(colour, alpha);
    graphic.drawRect(0, 0, width, height);
    graphic.endFill();

    return graphic;
}

export function getRectTexture(services: IServiceProvider, width: number, height: number, colour: number, resolution: number, alpha?: number): Texture {
    const graphics = drawRect(width, height, colour, alpha);
    const texture = graphicsToTexture(services, graphics, resolution);
    graphics.destroy({children: true, texture: true, baseTexture: true});
    return texture;
}

function graphicsToTexture(services: IServiceProvider, graphics: Graphics, resolution: number) {
    const renderTexture = RenderTexture.create({
        width: graphics.width,
        height: graphics.height,
        scaleMode: SCALE_MODES.LINEAR,
        resolution
    });
    services.application.renderer.render(graphics, {renderTexture});
    return renderTexture;
}

// export function getCircleTexture(radius: number, colour: number, resolution: number, alpha?: number): Texture {
//     return drawCircle(radius, colour, alpha).generateCanvasTexture(SCALE_MODES.LINEAR, resolution);
// }

// export function generateOverlay(services: GameServices, text: string, width: number, resolution: number): PIXI.Sprite {

//     const {application, factory} = services;

//     const container = new Graphics();
//     factory.createSpriteFromTexture(
//         getCircleTexture(width/2, 0xf8eb18, resolution),
//         {anchor: 0.5},
//         container
//     );

//     factory.createText(text, {
//         "x": 0,
//         "y": 0,
//         "anchor": 0.5,
//         "style": {
//             "fontSize": 4,
//             "fill": "#000000"
//         }
//     }, container);

//     const conTainertexture = application.renderer.generateTexture(container, SCALE_MODES.LINEAR, resolution);
//     return factory.createSpriteFromTexture(conTainertexture, {x: 0, y: 0, anchor: 0.5});
// }

// export function generateWildMultiplier(services: GameServices): PIXI.Text {

//     return services.factory.createText("", {
//         "x": 0,
//         "y": -11,
//         "anchor": 0.5,
//         "style": {
//             "fontSize": 8,
//             "fill": "#FFFFFF",
//             "strokes": [
//                 {"stroke": "#000000", "thickness": 1}
//             ]
//         }
//         });
// }

// export function generateButtonSprite(services: GameServices, text: string, width: number, height: number, colour: number,
//     resolution: number): PIXI.Sprite {

//     const {application, factory} = services;

//     const container = new Graphics();
//     factory.createSpriteFromTexture(
//         getRectTexture(services, width, height, colour, resolution),
//         {anchor: 0.5},
//         container
//     );

//     factory.createText(text, {
//         "x": 0,
//         "y": 0,
//         "anchor": 0.5,
//         "style": {
//             "fontSize": 5,
//             "fill": "#FFFFFF",
//             "resolutionMultiplier": 1.5
//         }
//     }, container);

//     const conTainertexture = application.renderer.generateTexture(container, PIXI.SCALE_MODES.LINEAR, resolution);
//     return factory.createSpriteFromTexture(conTainertexture, {x: 0, y: 0, anchor: 0.5});
// }

export function setSpineSkins(spine: Spine, skinNames: string[]): void {

    const combined = new Skin(`combined`);
    const spine4 = (spine as Spine4);

    skinNames.forEach(name => combined.addSkin(spine4.skeleton.data.findSkin(name)));

    spine4.skeleton.setSkin(combined);
    spine4.skeleton.setToSetupPose();
}

export function addToSpineSlot(spine: Spine, displayObject: DisplayObject, slotName: string) {

    const slotIndex = spine.skeleton.findSlotIndex(slotName);

    if (slotIndex >= 0) {
        (spine as any).children[slotIndex].addChild(displayObject);

    } else {
        throw new Error(`addToSpineSlot - Slot not found: ` + slotName);
    }
}

export function removeFromSpineSlot(spine: Spine, displayObject: DisplayObject, slotName: string): void {

    const slotIndex = spine.skeleton.findSlotIndex(slotName);

    if (slotIndex >= 0) {
        (spine as any).children[slotIndex].removeChild(displayObject);

    } else {
        throw new Error(`clearSpineSlot - Slot not found: ` + slotName);
    }
}

export function clearSpineSlot(spine: Spine, slotName: string): void {

    const slotIndex = spine.skeleton.findSlotIndex(slotName);

    if (slotIndex >= 0) {
        (spine as any).children[slotIndex].removeChildren();

    } else {
        throw new Error(`clearSpineSlot - Slot not found: ` + slotName);
    }
}

export function resetSpine(spine: Spine): void {

    spine.state.clearTracks();
    spine.state.clearListeners();
    spine.skeleton.setToSetupPose();
}